<template>
  <div class="unsubsribe">
    <div v-if="loading" style="display: flex; justify-content: center; align-items: center; width: 100%;">
      <Loading color="#217899" />
    </div>
    <v-data-table dense :headers="headers" :items="unsubsribes" sort-by="createdAt" :sort-desc="['desc']"
      class="elevation-1" hide-default-footer disable-pagination v-else>
    </v-data-table>
  </div>
</template>
<script>
import Loading from '../../components/loading.vue'
export default {
  name: "Unsubsribe",
  components: { Loading },
  data: () => ({
    loading: true,
    headers: [
      {
        text: "ИНН",
        align: "center",
        sortable: true,
        value: "inn",
      },
      { text: "Краткое наименование", value: "shortName", sortable: true },
      {
        text: "Дата отписки",
        value: "createdAt",
        sortable: true,
      },

      { text: "Почта", value: "email", sortable: true },
      { text: "Закон", value: "fz", sortable: true },
      { text: "Причина отписки", value: "description" },
    ],
  }),

  computed: {
    unsubsribes: {
      get() {
        return this.$store.getters.getUnsubscribes;
      },
    },
  },
  methods: {
    async init() {
      // if (!this.unsubsribes.length) {
      try {
        this.loading = true
        await this.$store.dispatch("GET_UNSUBSCRIBES");
      } finally {
        this.loading = false
      }
      // }
    },
  },
  async mounted() {
    await this.init();
  },
};
</script>
<style lang="sass" scoped></style>
